import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {axiosInstance} from '../services/Api';

// Async Thunks
export const fetchClientsFournisseurs = createAsyncThunk(
  'clientFournisseur/fetchClientsFournisseurs',
  async (filter, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/clients-fournisseurs/getFiltredClientFournisseur', filter);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);


export const addClientFournisseur = createAsyncThunk(
  'clientFournisseur/addClientFournisseur',
  async (clientData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/clients-fournisseurs', clientData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || 'Something went wrong');
    }
  }
);
export const updateClientFournisseur = createAsyncThunk(
  'clientsFournisseurs/updateClientFournisseur',
  async (clientData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/clients-fournisseurs', clientData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.message || 'Something went wrong');
    }
  }
);

export const deleteClientFournisseur = createAsyncThunk(
  'clientFournisseur/deleteClientFournisseur',
  async (id, { rejectWithValue }) => {
    try {
       await axiosInstance.delete(`/clients-fournisseurs/${id}`);
      return id; // Return the deleted ID to remove it from the state
    } catch (error) {
      return rejectWithValue(error.response?.data.message || 'Something went wrong');
    }
  }
);

// Slice
const clientFournisseurSlice = createSlice({
  name: 'clientFournisseur',
  initialState: {
    clientsFournisseursData: [],
    pagination: {},
    selectedClientFournisseur: null,
    message: null,
    loading: false,
    error: null,
  },
  reducers: {
    setSelectedClientFournisseur: (state, action) => {
      state.selectedClientFournisseur = action.payload;
    },
    clearSelectedClientFournisseur: (state) => {
      state.selectedClientFournisseur = null;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    clearAlerts: (state) => {
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchClientsFournisseurs cases
      .addCase(fetchClientsFournisseurs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClientsFournisseurs.fulfilled, (state, action) => {
        state.loading = false;
        state.pagination = action.payload.pagination;
        state.clientsFournisseursData = action.payload.clientsFournisseurs;
      })
      .addCase(fetchClientsFournisseurs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  
      // addClientFournisseur cases
      .addCase(addClientFournisseur.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addClientFournisseur.fulfilled, (state, action) => {
        state.loading = false;
        state.clientsFournisseursData.push(action.payload);
        state.message = 'Tiers added successfully';
      })
      .addCase(addClientFournisseur.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  
      // updateClientFournisseur cases
      .addCase(updateClientFournisseur.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClientFournisseur.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.clientsFournisseursData.findIndex(
          (client) => client._id === action.payload._id
        );
        if (index !== -1) {
          state.clientsFournisseursData[index] = action.payload;
        }
        state.message = 'Tiers updated successfully';
      })
      .addCase(updateClientFournisseur.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  
      // deleteClientFournisseur cases
      .addCase(deleteClientFournisseur.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClientFournisseur.fulfilled, (state, action) => {
        state.loading = false;
        state.clientsFournisseursData = state.clientsFournisseursData.filter(
          (client) => client._id !== action.payload
        );
        state.message = 'Tiers deleted successfully';
      })
      .addCase(deleteClientFournisseur.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    }});
  

export const {
  setSelectedClientFournisseur,
  clearSelectedClientFournisseur,
  setMessage,
  clearAlerts,
} = clientFournisseurSlice.actions;

export default clientFournisseurSlice.reducer;
